import { getPath } from '@/router/common'

const baseUrl = {
  title: '资金账户',
  path: 'myAccount'
}
const baseUrlLower = {
  title: '资金账户',
  path: 'MyAccount'
}

export default [
  {
    path: getPath('MyAccountInfo', baseUrl),
    name: 'MyAccountInfo',
    component: () => import(/* webpackChunkName: "MyAccountInfo" */ '@/views/myAccount/myAccountInfo/index.vue'),
    meta: {
      title: '账户信息'
    }
  },
  // 上面的都是定制版
  {
    path: getPath('TransactionRecords', baseUrl),
    name: 'TransactionRecords',
    component: () => import(/* webpackChunkName: "TransactionRecords" */ '@/views/myAccount/transactionRecords/index.vue'),
    meta: {
      title: '交易记录'
    }
  },
  {
    path: getPath('AccountRechargeAdd', baseUrl),
    name: 'AccountRechargeAdd',
    component: () => import(/* webpackChunkName: "AccountRechargeAdd" */ '@/views/myAccount/accountRechargeAdd/index.vue'),
    meta: {
      title: '账户充值'
    }
  },
  {
    path: getPath('AccountRecharge', baseUrl),
    name: 'AccountRecharge',
    component: () => import(/* webpackChunkName: "AccountRecharge" */ '@/views/myAccount/accountRecharge/index.vue'),
    meta: {
      title: '充值/提现记录'
    }
  },
  {
    path: getPath('AccountInfo', baseUrl),
    name: 'AccountInfo',
    component: () => import(/* webpackChunkName: "AccountInfo" */ '@/views/myAccount/accountInfo/index.vue'),
    meta: {
      title: '账户管理'
    }
  },
  { // 账户管理 新增或编辑
    path: getPath('AccountAddOrEdit', baseUrl),
    name: 'AccountAddOrEdit',
    component: () => import(/* webpackChunkName: "AccountAddOrEdit" */ '@/views/myAccount/accountAddOrEdit/index.vue'),
    meta: {
      title: '新增或编辑'
    }
  },
  {
    path: getPath('AccountRechargeRecord', baseUrl),
    name: 'AccountRechargeRecord',
    component: () => import(/* webpackChunkName: "AccountRechargeRecord" */ '@/views/myAccount/accountRechargeRecord/index.vue'),
    meta: {
      title: '充值/提现审批'
    }
  },
  {
    path: getPath('AccountChangeHandle', baseUrl),
    name: 'AccountChangeHandle',
    component: () => import(/* webpackChunkName: "AccountChangeHandle" */ '@/views/myAccount/accountChangeHandle/index.vue'),
    meta: {
      title: '账户变更'
    }
  },
  {
    path: getPath('AccountChange', baseUrl),
    name: 'AccountChange',
    component: () => import(/* webpackChunkName: "AccountChange" */ '@/views/myAccount/accountChange/index.vue'),
    meta: {
      title: '账户变更记录'
    }
  },
  {
    path: getPath('AccountProRate', baseUrl),
    name: 'AccountProRate',
    component: () => import(/* webpackChunkName: "AccountProRate" */ '@/views/myAccount/accountProRate/index.vue'),
    meta: {
      title: '分成比例'
    }
  },
  { // 分成比例跳转过来
    path: getPath('AccountProRateAdd', baseUrl),
    name: 'AccountProRateAdd',
    component: () => import(/* webpackChunkName: "AccountProRateAdd" */ '@/views/myAccount/accountProRateAdd/index.vue'),
    meta: {
      title: '分成比例操作'
    }
  },
  {
    path: getPath('AccountRechargeAdd_86308', baseUrl),
    name: 'MyAccount_AccountRechargeAdd_86308',
    component: () => import(/* webpackChunkName: "MyAccount_AccountRechargeAdd_86308" */ '@/views/myAccount/accountRechargeAdd_86308/index.vue'),
    meta: {
      title: '账户充值'
    }
  },
  {
    path: getPath('AccounTcarryoOver_86308', baseUrl),
    name: 'MyAccount_AccounTcarryoOver_86308',
    component: () => import(/* webpackChunkName: "MyAccount_AccounTcarryoOver_86308" */ '@/views/myAccount/accounTcarryoOver_86308/index.vue'),
    meta: {
      title: '账户转账'
    }
  },
  {
    path: getPath('AccountChangeHandle_79323', baseUrl),
    name: 'MyAccount_AccountChangeHandle_79323',
    component: () => import(/* webpackChunkName: "MyAccount_AccountChangeHandle_79323" */ '@/views/myAccount/accountChangeHandle_79323/index.vue'),
    meta: {
      title: '费用调整'
    }
  },
  {
    path: getPath('AccountChange_79323', baseUrl),
    name: 'MyAccount_AccountChange_79323',
    component: () => import(/* webpackChunkName: "MyAccount_AccountChange_79323" */ '@/views/myAccount/accountChange_79323/index.vue'),
    meta: {
      title: '费用调整记录'
    }
  },
  {
    path: getPath('AccountCztxamount', baseUrl),
    name: 'MyAccount_AccountCztxamount',
    component: () => import(/* webpackChunkName: "MyAccount_AccountCztxamount" */ '@/views/myAccount/accountCztxamount/index.vue'),
    meta: {
      title: '账户余额预警'
    }
  },
  {
    path: getPath('AccounTcarryoOverCheck_86308', baseUrl),
    name: 'MyAccount_AccounTcarryoOverCheck_86308',
    component: () => import(/* webpackChunkName: "MyAccount_AccounTcarryoOverCheck_86308" */ '@/views/myAccount/accounTcarryoOverCheck_86308/index.vue'),
    meta: {
      title: '网点转账审批'
    }
  },
  {
    path: getPath('AccountCapital', baseUrl),
    name: 'MyAccount_AccountCapital',
    component: () => import(/* webpackChunkName: "MyAccount_AccountCapital" */ '@/views/myAccount/accountCapital/index.vue'),
    meta: {
      title: '资金池管理'
    }
  },
  {
    path: getPath('costAscription', baseUrl),
    name: 'MyAccount_costAscription',
    component: () => import(/* webpackChunkName: "MyAccount_costAscription" */ '@/views/myAccount/costAscription/index.vue'),
    meta: {
      title: '费用归属'
    }
  },
  {
    path: getPath('AccountProRate_86308', baseUrl),
    name: 'MyAccount_AccountProRate_86308',
    component: () => import(/* webpackChunkName: "MyAccount_AccountProRate_86308" */ '@/views/myAccount/accountProRate_86308/index.vue'),
    meta: {
      title: '分成比例'
    }
  },
  {
    path: getPath('AccountProRate_80799', baseUrl),
    name: 'MyAccount_AccountProRate_80799',
    component: () => import(/* webpackChunkName: "MyAccount_AccountProRate_80799" */ '@/views/myAccount/accountProRate_80799/index.vue'),
    meta: {
      title: '分成比例'
    }
  },
  {
    path: getPath('ReconciliationOutlets_Main_82838', baseUrl),
    name: 'MyAccount_ReconciliationOutlets_Main_82838',
    component: () => import(/* webpackChunkName: "MyAccount_ReconciliationOutlets_Main_82838" */ '@/views/myAccount/reconciliationOutlets_Main_82838/index.vue'),
    meta: {
      title: '网点分成对账表'
    }
  },
  {
    path: getPath('PaymentOutlet_82838', baseUrl),
    name: 'MyAccount_PaymentOutlet_82838',
    component: () => import(/* webpackChunkName: "MyAccount_PaymentOutlet_82838" */ '@/views/myAccount/paymentOutlet_82838/index.vue'),
    meta: {
      title: '网点打款对账单'
    }
  },
  {
    path: getPath('AccountInfo_77335', baseUrl),
    name: 'MyAccount_AccountInfo_77335',
    component: () => import(/* webpackChunkName: "MyAccount_AccountInfo_77335" */ '@/views/myAccount/accountInfo_77335/index.vue'),
    meta: {
      title: '账户管理'
    }
  },
  {
    path: getPath('TransactionRecords_77335', baseUrl),
    name: 'MyAccount_TransactionRecords_77335',
    component: () => import(/* webpackChunkName: "MyAccount_TransactionRecords_77335" */ '@/views/myAccount/transactionRecords_77335/index.vue'),
    meta: {
      title: '交易记录'
    }
  },
  {
    path: getPath('AccountRechargeAdd_77335', baseUrl),
    name: 'MyAccount_AccountRechargeAdd_77335',
    component: () => import(/* webpackChunkName: "MyAccount_AccountRechargeAdd_77335" */ '@/views/myAccount/accountRechargeAdd_77335/index.vue'),
    meta: {
      title: '申请充值'
    }
  },
  {
    path: getPath('AccountRecharge_77335', baseUrl),
    name: 'MyAccount_AccountRecharge_77335',
    component: () => import(/* webpackChunkName: "MyAccount_AccountRecharge_77335" */ '@/views/myAccount/accountRecharge_77335/index.vue'),
    meta: {
      title: '充值/提现记录'
    }
  },
  {
    path: getPath('ManualTransfer_77335', baseUrl),
    name: 'MyAccount_ManualTransfer_77335',
    component: () => import(/* webpackChunkName: "MyAccount_ManualTransfer_77335" */ '@/views/myAccount/manualTransfer_77335/index.vue'),
    meta: {
      title: '手工划拨'
    }
  },
  {
    path: getPath('CostManage_77335', baseUrl),
    name: 'MyAccount_CostManage_77335',
    component: () => import(/* webpackChunkName: "MyAccount_CostManage_77335" */ '@/views/myAccount/costManage_77335/index.vue'),
    meta: {
      title: '申请费用'
    }
  },
  {
    path: getPath('ProjectDefinition_77335', baseUrl),
    name: 'MyAccount_ProjectDefinition_77335',
    component: () => import(/* webpackChunkName: "MyAccount_ProjectDefinition_77335" */ '@/views/myAccount/projectDefinition_77335/index.vue'),
    meta: {
      title: '项目定义'
    }
  },
  {
    path: getPath('ReconciliationOutlets_82838', baseUrl),
    name: 'MyAccount_ReconciliationOutlets_82838',
    component: () => import(/* webpackChunkName: "MyAccount_ReconciliationOutlets_82838" */ '@/views/myAccount/reconciliationOutlets_82838/index.vue'),
    meta: {
      title: '新增修改网点分成对账表'
    }
  },
  {
    path: getPath('AccountAddOrEdit_77335', baseUrl),
    name: 'MyAccount_AccountAddOrEdit_77335',
    component: () => import(/* webpackChunkName: "MyAccount_AccountAddOrEdit_77335" */ '@/views/myAccount/accountAddOrEdit_77335/index.vue'),
    meta: {
      title: '新增账户|账户修改'
    }
  },
  {
    path: getPath('ManualTransferAdd_77335', baseUrl),
    name: 'MyAccount_ManualTransferAdd_77335',
    component: () => import(/* webpackChunkName: "MyAccount_ManualTransferAdd_77335" */ '@/views/myAccount/manualTransferAdd_77335/index.vue'),
    meta: {
      title: '新增修改'
    }
  },
  {
    path: getPath('CostOperate_77335', baseUrl),
    name: 'MyAccount_CostOperate_77335',
    component: () => import(/* webpackChunkName: "MyAccount_CostOperate_77335" */ '@/views/myAccount/costOperate_77335/index.vue'),
    meta: {
      title: '申请费用'
    }
  },
  {
    path: getPath('add', baseUrl),
    name: 'MyAccount_add',
    component: () => import(/* webpackChunkName: "MyAccount_add" */ '@/views/myAccount/add/index.vue'),
    meta: {
      title: '导入开户资料信息'
    }
  },
  {
    path: getPath('AccountChangeImportSearch', baseUrl),
    name: 'MyAccount_AccountChangeImportSearch',
    component: () => import(/* webpackChunkName: "MyAccount_AccountChangeImportSearch" */ '@/views/myAccount/accountChangeImportSearch/index.vue'),
    meta: {
      title: '账户变更导入'
    }
  },
  {
    path: getPath('AccountChangeImport', baseUrl),
    name: 'MyAccount_AccountChangeImport',
    component: () => import(/* webpackChunkName: "MyAccount_AccountChangeImport" */ '@/views/myAccount/accountChangeImport/index.vue'),
    meta: {
      title: '导入账户变更记录'
    }
  },
  {
    path: getPath('AccountChangeImportDetail', baseUrl),
    name: 'MyAccount_AccountChangeImportDetail',
    component: () => import(/* webpackChunkName: "MyAccount_AccountChangeImportDetail" */ '@/views/myAccount/accountChangeImportDetail/index.vue'),
    meta: {
      title: '账户变更记录明细'
    }
  },
  {
    path: getPath('AccountProRateAdd_82838', baseUrl),
    name: 'MyAccount_AccountProRateAdd_82838',
    component: () => import(/* webpackChunkName: "MyAccount_AccountProRateAdd_82838" */ '@/views/myAccount/accountProRateAdd_82838/index.vue'),
    meta: {
      title: '新增修改比例'
    }
  },
  {
    path: getPath('intervalSetting', baseUrlLower),
    name: 'MyAccount_intervalSetting',
    component: () => import(/* webpackChunkName: "MyAccount_intervalSetting" */ '@/views/myAccount/intervalSetting/index.vue'),
    meta: {
      title: '区间段设置'
    }
  },
  {
    path: getPath('intervalSettingAdd', baseUrlLower),
    name: 'MyAccount_intervalSettingAdd',
    component: () => import(/* webpackChunkName: "MyAccount_intervalSettingAdd" */ '@/views/myAccount/intervalSettingAdd/index.vue'),
    meta: {
      title: '区间段设置新增'
    }
  },
  {
    path: getPath('intervalSetting_77335', baseUrlLower),
    name: 'MyAccount_intervalSetting_77335',
    component: () => import(/* webpackChunkName: "MyAccount_intervalSetting_77335" */ '@/views/myAccount/intervalSetting_77335/index.vue'),
    meta: {
      title: '区间段设置'
    }
  },
  {
    path: getPath('intervalSettingAdd_77335', baseUrlLower),
    name: 'MyAccount_intervalSettingAdd_77335',
    component: () => import(/* webpackChunkName: "MyAccount_intervalSettingAdd_77335" */ '@/views/myAccount/intervalSettingAdd_77335/index.vue'),
    meta: {
      title: '区间段设置新增'
    }
  },
  {
    path: getPath('intervalSetting_82233', baseUrlLower),
    name: 'MyAccount_intervalSetting_82233',
    component: () => import(/* webpackChunkName: "MyAccount_intervalSetting_82233" */ '@/views/myAccount/intervalSetting_82233/index.vue'),
    meta: {
      title: '区间段设置'
    }
  },
  {
    path: getPath('intervalSettingAdd_82233', baseUrlLower),
    name: 'MyAccount_intervalSettingAdd_82233',
    component: () => import(/* webpackChunkName: "MyAccount_intervalSettingAdd_82233" */ '@/views/myAccount/intervalSettingAdd_82233/index.vue'),
    meta: {
      title: '区间段设置新增'
    }
  },
  {
    path: getPath('SettlementTransfer', baseUrlLower),
    name: 'MyAccount_SettlementTransfer',
    component: () => import(/* webpackChunkName: "MyAccount_SettlementTransfer" */ '@/views/myAccount/settlementTransfer/index.vue'),
    meta: {
      title: '结算中转费标准'
    }
  },
  {
    path: getPath('SettlementDelivery', baseUrlLower),
    name: 'MyAccount_SettlementDelivery',
    component: () => import(/* webpackChunkName: "MyAccount_SettlementDelivery" */ '@/views/myAccount/settlementDelivery/index.vue'),
    meta: {
      title: '结算送货费标准'
    }
  },
  {
    path: getPath('GroundLine', baseUrlLower),
    name: 'MyAccount_GroundLine',
    component: () => import(/* webpackChunkName: "MyAccount_GroundLine" */ '@/views/myAccount/groundLine/index.vue'),
    meta: {
      title: '干线费标准'
    }
  },
  {
    path: getPath('Upstairs', baseUrlLower),
    name: 'MyAccount_Upstairs',
    component: () => import(/* webpackChunkName: "MyAccount_Upstairs" */ '@/views/myAccount/upstairs/index.vue'),
    meta: {
      title: '上楼费标准'
    }
  },
  {
    path: getPath('Unload', baseUrlLower),
    name: 'MyAccount_Unload',
    component: () => import(/* webpackChunkName: "MyAccount_Unload" */ '@/views/myAccount/unload/index.vue'),
    meta: {
      title: '卸货费标准'
    }
  },
  {
    path: getPath('OtherExpenses', baseUrlLower),
    name: 'MyAccount_OtherExpenses',
    component: () => import(/* webpackChunkName: "MyAccount_OtherExpenses" */ '@/views/myAccount/otherExpenses/index.vue'),
    meta: {
      title: '各项费用标准'
    }
  },
  {
    path: getPath('Delivery', baseUrlLower),
    name: 'MyAccount_Delivery',
    component: () => import(/* webpackChunkName: "MyAccount_Delivery" */ '@/views/myAccount/delivery/index.vue'),
    meta: {
      title: '协议送货费标准'
    }
  },
  {
    path: getPath('specialRatio_77335', baseUrlLower),
    name: 'MyAccount_specialRatio_77335',
    component: () => import(/* webpackChunkName: "MyAccount_specialRatio_77335" */ '@/views/myAccount/specialRatio_77335/index.vue'),
    meta: {
      title: '重泡比设置'
    }
  },
  {
    path: getPath('outaccBZ_7735', baseUrlLower),
    name: 'MyAccount_outaccBZ_7735',
    component: () => import(/* webpackChunkName: "MyAccount_outaccBZ_7735" */ '@/views/myAccount/outaccBZ_7735/index.vue'),
    meta: {
      title: '运费价格标准'
    }
  },
  {
    path: getPath('specialRatio_82233', baseUrlLower),
    name: 'MyAccount_specialRatio_82233',
    component: () => import(/* webpackChunkName: "MyAccount_specialRatio_82233" */ '@/views/myAccount/specialRatio_82233/index.vue'),
    meta: {
      title: '重泡比设置'
    }
  },
  {
    path: getPath('outaccBZ_82233', baseUrlLower),
    name: 'MyAccount_outaccBZ_82233',
    component: () => import(/* webpackChunkName: "MyAccount_outaccBZ_82233" */ '@/views/myAccount/outaccBZ_82233/index.vue'),
    meta: {
      title: '运费价格标准'
    }
  }
]
